import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Box from 'components/Box';
import Flag from 'components/Flag';
import Icon from 'components/Icon';
import PageTitle from 'components/PageTitle';
import ShadedCard from 'components/ShadedCard';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import { MainThumbnailPreviewModalWrapper } from '.';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function Wrapper(props) {
  var id = props.id,
    aspectRatio = props.aspectRatio,
    children = props.children,
    recommendedSize = props.recommendedSize,
    onClose = props.onClose,
    title = props.title;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(MainThumbnailPreviewModalWrapper, {
    id: id,
    onClose: onClose,
    pageSections: children,
    children: [/*#__PURE__*/_jsx(PageTitle, {
      size: "large",
      mb: "s",
      children: title
    }), /*#__PURE__*/_jsxs(ShadedCard, {
      px: "m",
      py: "s",
      width: "100%",
      maxWidth: 550,
      children: [/*#__PURE__*/_jsx(Flag, {
        token: /*#__PURE__*/_jsx(Icon, {
          name: "info",
          scale: 1.5
        }),
        spacing: "s",
        children: /*#__PURE__*/_jsxs("p", {
          children: [t('thumbnail_preview_aspect_ratio'), ":", ' ', /*#__PURE__*/_jsx("b", {
            children: aspectRatio
          }), /*#__PURE__*/_jsx("br", {}), recommendedSize && /*#__PURE__*/_jsxs(_Fragment, {
            children: [t('thumbnail_preview_recommended_file_size'), ":", ' ', /*#__PURE__*/_jsx("b", {
              children: recommendedSize
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(Box, {
        my: "xs",
        borderBottom: "thin"
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        size: "s",
        children: /*#__PURE__*/_jsxs(Trans, {
          t: t,
          i18nKey: "thumbnail_preview_view_guide",
          children: ["Please also view the", /*#__PURE__*/_jsx(TextLink, {
            bold: true,
            href: "https://docs.5app.com/guides/creating-artwork",
            target: "_blank",
            children: "Content Artwork Guide"
          }), "on our website and resize your browser window to preview what these components look like across different screen sizes."]
        })
      })]
    })]
  });
}
export default Wrapper;